import { z } from 'zod'
import { SuccessEnvelope, Uuid } from './common.js'

export const MasterItem = z.object({
  id: Uuid,
  name: z.string(),
  slug: z.string(),
  display_order: z.number(),
  is_popular: z.boolean().optional(),
  // segments only
  is_primary: z.boolean().optional(),
  // sub-industries carry their parent group
  group_id: Uuid.optional(),
  group_slug: z.string().optional(),
  group_name: z.string().optional(),
})

export const PronounsResponse = SuccessEnvelope(
  z.object({ pronouns: z.array(MasterItem) }),
)
export const CitiesResponse = SuccessEnvelope(
  z.object({ cities: z.array(MasterItem) }),
)
export const IndustriesResponse = SuccessEnvelope(
  z.object({ industries: z.array(MasterItem) }),
)
export const ProfessionsResponse = SuccessEnvelope(
  z.object({ professions: z.array(MasterItem) }),
)
export const CategoriesResponse = SuccessEnvelope(
  z.object({ categories: z.array(MasterItem) }),
)
export const IndustryGroupsResponse = SuccessEnvelope(
  z.object({ industry_groups: z.array(MasterItem) }),
)
export const PersonasResponse = SuccessEnvelope(
  z.object({ personas: z.array(MasterItem) }),
)
export const StartupStagesResponse = SuccessEnvelope(
  z.object({ startup_stages: z.array(MasterItem) }),
)
export const SegmentsResponse = SuccessEnvelope(
  z.object({ segments: z.array(MasterItem) }),
)
export const LookingForResponse = SuccessEnvelope(
  z.object({ looking_for: z.array(MasterItem) }),
)
